import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const MintScheduleFragment = graphql(
  `
    fragment MintSchedule on DropStage {
      startTime
      endTime
      label
      stageIndex
      price {
        ...TokenPrice
      }
      maxTotalMintableByWallet
    }
  `,
  [TokenPriceFragment],
)
